import { useContext, useMemo } from 'react';
import { SPOILER_TYPE } from 'ricos-content';
import { PluginsContext } from 'ricos-context';

import { IMAGE_TYPE } from '../types';

export const useSpoilerPlugin = (): boolean => {
  const plugins = useContext(PluginsContext);

  return useMemo(() => {
    const spoilerPlugin = plugins.asArray().find(plugin => plugin.getType() === SPOILER_TYPE);
    const isSpoilerPluginAvailable =
      spoilerPlugin &&
      (!spoilerPlugin.getConfig().supportedPlugins ||
        spoilerPlugin.getConfig().supportedPlugins.includes(IMAGE_TYPE));

    return isSpoilerPluginAvailable;
  }, [plugins]);
};
